const initialState = { 
  loading: false,
  success: null,
  error: null
}

function acceptWithdrawalReducer(state = initialState, action) {
  switch (action.type) {
    case 'ACCEPT_WITHDRAWAL_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'ACCEPT_WITHDRAWAL_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'ACCEPT_WITHDRAWAL_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default acceptWithdrawalReducer
